import * as React from "react";
const SvgCaretRight = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m8.621 1.5-1.809.002-1.808.004L5 11.996c-.002 5.77.002 10.492.006 10.496.004.004.82.008 1.812.008h1.803l5.19-5.25L19 12l-5.19-5.25Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgCaretRight;
